import { useFormikContext } from 'formik'
import { Button } from 'blaze-ui/Button'
import { Grid } from 'blaze-ui/icons'
import { ShowMoreImagesButtonProps } from 'components/Wizards/SelectImages/Types'
import { useUnsplashImages } from 'components/Wizards/SelectImages/ImagesProvider'

export const ShowMoreImagesButton = ({
  variant = 'secondary',
  size = 'md',
  frontIcon = Grid,
  onShowMore,
  ...props
}: ShowMoreImagesButtonProps) => {
  const { setPage, page } = useUnsplashImages()
  const { isSubmitting } = useFormikContext()

  const handlePress = async () => {
    setPage(page + 1)
    onShowMore()
  }

  return (
    <Button
      isDisabled={isSubmitting}
      onPress={handlePress}
      variant={variant}
      size={size}
      frontIcon={frontIcon}
      aria-label="Show More Images"
      {...props}
    >
      Show More
    </Button>
  )
}
